import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {getFromHubNew} from "../../actions/networkActions";
import {store} from "../../App";
import {useGet} from "../../hooks/useGet";
import PresalesExcursionDetail from "../../components/presalesExcursions/PresalesExcursionDetail";
import {useExcursionImages} from "../../hooks/useExcursionImages";
import FullScreenLoader from '../../components/FullScreenLoader';
import {checkExcursionPriceValidity} from "../../utils/excursionsUtils";

// TODO refactor the useEffects that need to transform data to also use useGet hook
function OnboardExcursionDetail(props) {
    const tags = useSelector(state => state.excursionTags);
    const [loadingTags, setLoadingTags] = useState(false);
    const images = useExcursionImages(props.match.params.id);
    const [descriptions, setDescriptions] = useState(null);
    const [availability, setAvailability] = useState(null);

    const excursion = useGet(`excursions/${props.match.params.id}`);

    const dispatch = store.dispatch;

    useEffect(() => {
        if(tags || loadingTags) {
            return;
        }

        const fetchTags = async () => {
            const tagsData = await getFromHubNew('excursions/tags');

            const tagsObject = {};
            tagsData.forEach(tag => {
                tagsObject[tag.code] = tag.imageUrl?.id;
            });

            dispatch({
                type: "SET_TAGS",
                tags: tagsObject,
            });
        }
        setLoadingTags(true);
        fetchTags();

    }, [dispatch, loadingTags, tags])

    useEffect(() => {
        const fetchDescriptions = async () => {
            const descriptionsArray = await getFromHubNew(`descriptions/${props.match.params.id}`);

            const descriptionsObject = descriptionsArray.reduce((result, entry) => {
                result[entry.descriptionType] = entry.value;
                return result;
            }, {});

            setDescriptions(descriptionsObject);
        }

        fetchDescriptions();
    }, [props.match.params.id]);

    useEffect(() => {
        if(!excursion.data || excursion.data.day){
            return;
        }
        const fetchAvailability = async () => {
            const availabilityData = await getFromHubNew(`excursions/checkAvailability/${props.match.params.id}`);
            setAvailability(availabilityData);
        }
        fetchAvailability();
    }, [props.match.params.id, excursion]);


    if(images.length === 0 || excursion.data === null || descriptions === null || (availability === null && !excursion.data.day) ) {
        return (
            <FullScreenLoader />
        )
    }

    return (
        <div>
            <PresalesExcursionDetail
                tags={tags}
                excursion={excursion.data}
                currentAvailability={availability?.currentAvailability ? availability.currentAvailability : availability?.availability ? 99 : 0}
                showPriceWithoutBookNow={Boolean(!availability && checkExcursionPriceValidity(excursion.data))}
                closedForOnlineBooking={availability?.closedForOnlineBooking}
                images={images}
                descriptions={descriptions}
            />
        </div>
    );
}

export default OnboardExcursionDetail;